import Container from "../components/landing/Container";
import Header from "../components/Terms/Header";
import TermsComponent from "../components/Terms";

export default function Terms() {
  return (
    <div style={{ background: "white" }}>
      <Container>
        <Header />
        <TermsComponent />
      </Container>
    </div>
  );
}
